import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import {FormSendType} from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import Config from '../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import vIcon from '../Icons/v.svg';

const SuccessPageOneForm = (props) => {
  const styledNumber = (number) => {
    return number?.replace(/^(.{3})(.*)$/, '$1-$2');
  };

  return (
    <div className='stepContainer'>
      <Image src={vIcon} />

      <div>
        {props.data.subscriberSendFormType.type == FormSendType.sms && (
          <div className='l-title'>
            טופס לחתימה נשלח למנוי <span className='no-wrap'>{styledNumber(props.data.subscriberSendFormType.sms)}</span> בהצלחה
          </div>
        )}
        {props.data.subscriberSendFormType.type == FormSendType.email && (
          <div>
            <div className='l-title'>
              טופס לחתימה נשלח למנוי <span className='no-wrap'>{styledNumber(props.data.selectedPhoneNumber)}</span> בהצלחה לכתובת המייל
              שהזנת
            </div>
            <div className='m-title'>{props.data.subscriberSendFormType.email}</div>
          </div>
        )}
      </div>
      <div className='m-title'>על המנוי לחתום על הטופס בהקדם כדי לאפשר את המשך תהליך העברת הבעלות</div>
      <div className='continue-button'>
        <BtnSubmit text={isMobile ? 'להעברת קו נוסף' : 'לצפייה בכל העברות הבעלות'} onclick={() => props.nextStepSuccessPage()} />
        <BtnWhiteBlackBorderBigSize text={'לאזור האישי'} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPageOneForm);
